"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCourseContract = exports.addCourseContract = exports.getCourseContracts = exports.getProductRateById = exports.updateProductRates = exports.deleteRate = exports.addRates = exports.deleteProduct = exports.deleteContract = exports.addProduct = exports.updateProduct = exports.deleteContractComment = exports.addContractComment = exports.getContractComments = exports.updateCourse = exports.updateCourses = exports.getCourse = exports.addCourse = exports.getCourseReview = exports.getCourseReviews = exports.updateCourseReview = exports.getCourses = exports.getCourseCombosByRegion = exports.getCoursesByRegion = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const _ = require("lodash");
const utilities_1 = require("../utilities");
const isProductInvalid = (product, policies) => {
    if (policies?.caddies?.enabled === "YES" && !product?.caddie_price) {
        return true;
    }
    if (policies?.carts?.enabled === "YES" &&
        policies?.carts?.single_carts &&
        policies?.carts?.policy === "") {
        return true;
    }
    if (policies?.carts?.enabled === "YES" &&
        policies?.carts?.single_carts &&
        !product?.single_cart_price) {
        return true;
    }
    if (policies?.carts?.enabled === "YES" &&
        policies?.carts?.shared_carts &&
        !product?.shared_cart_price) {
        return true;
    }
    return false;
};
const getCoursesByRegion = async (supabase, region_id) => {
    const { data: courses, error } = await supabase
        .from("courses")
        .select(`id,
      name, 
      published,
      nickname,
      slug, 
      holes,
      images, 
      longitude,
      latitude,
      summary, 
      short_desc,
      price_range,
      course_type,
      is_recommended,
      days_of_operation,
      policies,
      hole_options,
      facilities,
      area:areas!area_id(*),   
      course_warnings(*),   
      course_closures(*),      
      course_reviews(*),
      golf_contracts(*,
        products:golf_contract_products(
          *,
          product:product_id(*),
          rates:golf_contract_product_rates(
            *
          )
        )
      ),
      region:region_id( 
        id, 
        name, 
        slug, 
        weekend_days,
        country:country_id
        (
          id,
          name,
          slug
        )
      )`)
        .or(`alt_region_id.eq.${region_id},region_id.eq.${region_id}`)
        .order("name->en", { ascending: true });
    if (!error)
        return courses.map((course) => {
            // get the golf contract ending latest]
            const course_reviews = course?.course_reviews;
            return {
                id: course.id,
                name: course.name,
                holes: course.holes,
                published: course.published,
                nickname: course.nickname,
                short_desc: course.short_desc,
                slug: course.slug,
                latitude: course.latitude,
                longitude: course.longitude,
                facilities: course.facilities,
                hole_options: course.hole_options,
                images: JSON.parse(course.images),
                summary: course.summary,
                days_of_operation: course.days_of_operation,
                price_range: course.price_range,
                course_type: course.course_type,
                is_recommended: course.is_recommended,
                policies: course.policies,
                course_closures: course.course_closures,
                reviews: {
                    reviews: course_reviews,
                    count: course_reviews?.length || 0,
                    average_rating: (0, utilities_1.getAverageRating)(course_reviews),
                },
                course_warnings: course.course_warnings,
                golf_contracts: course.golf_contracts,
                area: {
                    id: course?.area?.id,
                    name: course?.area?.name,
                },
                region: {
                    id: course?.region?.id,
                    name: course?.region?.name,
                    slug: course?.region?.slug,
                    weekend_days: course?.region?.weekend_days,
                    country: {
                        id: course?.region?.country?.id,
                        name: course?.region?.country?.name,
                        slug: course?.region?.country?.slug,
                    },
                },
            };
        });
    //.filter((course: Course) => course.golf_contracts.length > 0)
    return error;
};
exports.getCoursesByRegion = getCoursesByRegion;
const getCourseCombosByRegion = async (supabase, region_id) => {
    const { data, error } = await supabase
        .from("course_combos")
        .select(`id, name, courses`)
        .eq("region_id", region_id)
        .order("name", { ascending: true });
    if (!error)
        return data;
    return error;
};
exports.getCourseCombosByRegion = getCourseCombosByRegion;
const getCourses = async (supabase) => {
    const { data: courses, error } = await supabase
        .from("courses")
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name), 
      course_reviews(count),name, published, holes, slug,  
      golf_contracts(booking_window_start_date, booking_window_end_date,
        golf_contract_products(
          *,
          products:product_id(*)
        )
      ),
      region:region_id ( id, name, slug, country:country_id ( id, name, slug ) )`)
        .order("name->en", { ascending: true });
    if (!error)
        return courses.map((course) => {
            // get the golf contract ending latest]
            const latestContract = _.maxBy(course.golf_contracts, (c) => {
                return c.booking_window_end_date;
            });
            const incompleteContracts = course.golf_contracts.filter((c) => {
                const invalidProducts = c.golf_contract_products.filter((p) => {
                    return isProductInvalid(p, course.policies);
                });
                return invalidProducts.length > 0;
            });
            return {
                id: course.id,
                facilities: course.facilities,
                is_recommended: course.is_recommended,
                created_at: course.created_at,
                modified_at: course.modified_at,
                modified_by_user: course.modified_by_user,
                created_by_user: course.created_by_user,
                course_reviews: course.course_reviews,
                name: course.name,
                holes: course.holes,
                contract_expiry_date: latestContract?.booking_window_end_date,
                incomplete_policies: (0, utilities_1.hasInvalidPolicySections)(course.policies).length,
                incomplete_contract: incompleteContracts.length > 0 ||
                    (0, utilities_1.hasInvalidPolicies)(course.policies).length > 0,
                published: course.published,
                policies: course.policies,
                slug: course.slug,
                region: {
                    id: course.region.id,
                    name: course.region.name,
                    slug: course.region.slug,
                },
                country: {
                    id: course.region.country.id,
                    name: course.region.country.name,
                    slug: course.region.country.slug,
                },
            };
        });
    return error;
};
exports.getCourses = getCourses;
const updateCourseReview = async (supabase, review) => {
    const obj = _.cloneDeep(review);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        obj.modified_by = user?.id;
    }
    delete obj.created_by_user;
    delete obj.modified_by_user;
    const { data, error } = await supabase.from("course_reviews").upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.updateCourseReview = updateCourseReview;
const getCourseReviews = async (supabase, course_id) => {
    const { data: reviews, error } = await supabase
        .from("course_reviews")
        .select(`*,  
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("course_id", course_id);
    if (!error)
        return reviews;
    return error;
};
exports.getCourseReviews = getCourseReviews;
const getCourseReview = async (supabase, id) => {
    const { data: review, error } = await supabase
        .from("course_reviews")
        .select(`*,  
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return review;
    return error;
};
exports.getCourseReview = getCourseReview;
const addCourse = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        obj.modified_by = user?.id;
        obj.created_by = user?.id;
    }
    const { data, error } = await supabase
        .from("courses")
        .insert([obj])
        .select()
        .single();
    //Create an area for the course
    await supabase.from("areas").insert([
        {
            id: data.id,
            name: obj.name,
            region_id: obj.region_id,
            longitude: obj.longitude,
            latitude: obj.latitude,
            created_at: obj.created_at,
            modified_at: obj.modified_at,
            created_by: obj.created_by,
            modified_by: obj.modified_by,
            type: "Course",
        },
    ]);
    if (!error)
        return data;
    return error;
};
exports.addCourse = addCourse;
const getCourse = async (supabase, id) => {
    const { data: course, error } = await supabase
        .from("courses")
        .select(`*,  
      course_closures(*),
      course_warnings(*),
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name), 
      course_reviews(*), region:region_id ( id, name, slug, country:country_id ( id, name, slug ) )`)
        .eq("id", id)
        .single();
    if (!error)
        return {
            ...course,
            region: {
                id: course.region.id,
                name: course.region.name,
                slug: course.region.slug,
            },
            country: {
                id: course.region.country.id,
                name: course.region.country.name,
                slug: course.region.country.slug,
            },
        };
    return error;
};
exports.getCourse = getCourse;
const updateCourses = async (supabase, updateObj) => {
    const { data, error } = await supabase.from("courses").upsert(updateObj);
    if (!error)
        return data;
    return error;
};
exports.updateCourses = updateCourses;
const updateCourse = async (supabase, obj, select) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
    }
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    delete updateObj.course_closures;
    delete updateObj.course_warnings;
    const { data, error } = await supabase
        .from("courses")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(select ||
        `*,  
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name), 
      course_reviews(*), region:region_id ( id, name, slug, country:country_id ( id, name, slug ) )`)
        .single();
    // Update an area if it has changed
    await supabase
        .from("areas")
        .update({
        name: updateObj.name,
        longitude: updateObj.longitude,
        latitude: updateObj.latitude,
    })
        .eq("id", updateObj.id);
    if (!error)
        return data;
    return error;
};
exports.updateCourse = updateCourse;
const getContractComments = async (supabase, id) => {
    const { data, error } = await supabase
        .from("golf_contract_notes")
        .select(`*,
    modified_by_user:modified_by(id, first_name, last_name), 
    created_by_user:created_by(id, first_name, last_name)`)
        .eq("golf_contract_id", id)
        .order("created_at", { ascending: false });
    if (!error)
        return data;
    return error;
};
exports.getContractComments = getContractComments;
const addContractComment = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    obj.modified_by = user?.id;
    obj.created_by = user?.id;
    const { data, error } = await supabase
        .from("golf_contract_notes")
        .insert([obj])
        .single();
    if (!error)
        return data;
    return error;
};
exports.addContractComment = addContractComment;
const deleteContractComment = async (supabase, id) => {
    const { data, error } = await supabase
        .from("golf_contract_notes")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteContractComment = deleteContractComment;
const updateProduct = async (supabase, product) => {
    const obj = _.cloneDeep(product);
    // delete rates
    delete obj.rates;
    delete obj.config;
    const { data, error } = await supabase
        .from("golf_contract_products")
        .upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.updateProduct = updateProduct;
const addProduct = async (supabase, product) => {
    const obj = _.cloneDeep(product);
    // delete rates
    delete obj.rates;
    delete obj.config;
    const { data, error } = await supabase
        .from("golf_contract_products")
        .insert([obj])
        .select()
        .single();
    if (!error)
        return data;
    return error;
};
exports.addProduct = addProduct;
const deleteContract = async (supabase, id) => {
    await supabase
        .from("golf_contract_notes")
        .delete()
        .eq("golf_contract_id", id);
    const { data, error } = await supabase
        .from("golf_contracts")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteContract = deleteContract;
const deleteProduct = async (supabase, id) => {
    await supabase
        .from("golf_contract_product_rates")
        .delete()
        .eq("contract_product_id", id);
    const { data, error } = await supabase
        .from("golf_contract_products")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteProduct = deleteProduct;
const addRates = async (supabase, obj) => {
    const { data, error } = await supabase
        .from("golf_contract_product_rates")
        .upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.addRates = addRates;
const deleteRate = async (supabase, id) => {
    const { data, error } = await supabase
        .from("golf_contract_product_rates")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteRate = deleteRate;
const updateProductRates = async (supabase, rates) => {
    const obj = _.cloneDeep(rates);
    // in each rate delete the contract_id property
    obj.forEach((rate) => {
        delete rate.contract_id;
    });
    const { data, error } = await supabase
        .from("golf_contract_product_rates")
        .upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.updateProductRates = updateProductRates;
const getProductRateById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("golf_contract_product_rates")
        .select("*")
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getProductRateById = getProductRateById;
const getCourseContracts = async (supabase, id) => {
    const { data: product_types, error: product_types_error } = await supabase
        .from("golf_product_types")
        .select("*");
    const { data: course, error: hole_options_error } = await supabase
        .from("courses")
        .select("id, name, policies, hole_options")
        .eq("id", id)
        .single();
    const { data: platforms, error: platforms_error } = await supabase
        .from("platforms")
        .select("*");
    const { data: contracts, error } = await supabase
        .from("golf_contracts")
        .select(`*, 
      course:course_id (id, name, hole_options), 
      supplier:supplier_id (id, name, currency), 
      golf_contract_notes(count),
      golf_contract_products(
        *,
        products:product_id(*),
        golf_contract_product_rates(
          *
        )
      )`)
        .eq("course_id", id);
    if (!error && !product_types_error && !platforms_error && !hole_options_error)
        return {
            hole_options: course.hole_options,
            policies: course.policies,
            course: {
                id: course.id,
                name: course.name,
            },
            golf_product_types: product_types,
            platforms: platforms,
            contracts: contracts.length === 0
                ? []
                : contracts.map((contract) => ({
                    id: contract.id,
                    currency_code: contract.currency_code,
                    start_date: contract.start_date,
                    end_date: contract.end_date,
                    booking_window_start_date: contract.booking_window_start_date,
                    booking_window_end_date: contract.booking_window_end_date,
                    type: contract.type,
                    payment_terms: contract.payment_terms,
                    created_at: contract.created_at,
                    platforms: contract.platforms,
                    promotion: contract.promotion,
                    comments_count: contract.golf_contract_notes[0].count,
                    supplier: {
                        id: contract.supplier.id,
                        name: contract.supplier.name,
                        currency: contract.supplier.currency,
                    },
                    products: contract.golf_contract_products.map((product) => ({
                        id: product.id,
                        product_id: product.product_id,
                        config: product.products?.config,
                        contract_id: contract.id,
                        note: product.note,
                        course_hole_combination: product.course_hole_combination,
                        single_cart_price: product.single_cart_price,
                        odd_number_surcharge: product.odd_number_surcharge,
                        shared_cart_price: product.shared_cart_price,
                        caddie_price: product.caddie_price,
                        walk_in_rate: product.walk_in_rate,
                        single_cart_enabled: product.single_cart_enabled,
                        shared_cart_enabled: product.shared_cart_enabled,
                        caddie_price_enabled: product.caddie_price_enabled,
                        odd_number_surcharge_enabled: product.odd_number_surcharge_enabled,
                        created_at: product.created_at,
                        rates: product.golf_contract_product_rates.map((rate) => ({
                            id: rate.id,
                            caddie_policy: rate.caddie_policy,
                            cart_policy: rate.cart_policy,
                            reference_rate: rate.reference_rate,
                            contract_id: contract.id,
                            contract_product_id: product.id,
                            product_type_id: rate.product_type_id,
                            availability_days: rate.availability_days,
                            earliest_time: rate.earliest_time,
                            latest_time: rate.latest_time,
                            min_pax: rate.min_pax,
                            max_pax: rate.max_pax,
                            multiples: rate.multiples,
                            cost_price: rate.cost_price,
                            margin: rate.margin,
                            sell_price: rate.sell_price,
                            prepaid: rate.prepaid,
                            voucher_collection_id: rate.voucher_collection_id,
                            created_at: rate.created_at,
                        })),
                    })),
                })),
        };
};
exports.getCourseContracts = getCourseContracts;
const addCourseContract = async (supabase, obj) => {
    const { data, error } = await supabase.from("golf_contracts").upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.addCourseContract = addCourseContract;
const updateCourseContract = async (supabase, contracts) => {
    const obj = _.cloneDeep(contracts);
    obj.forEach((contract) => {
        delete contract.products;
    });
    const { data, error } = await supabase.from("golf_contracts").upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.updateCourseContract = updateCourseContract;
